export const GUID_EMPTY = '00000000-0000-0000-0000-000000000000'

export const SPEDILINK_LINK_TYPES = {
  FREIGHT: 1,
  VEHICLE: 2
}

export const SPEDILINK_ROUTE_NAMES = {
  CARGO_LIST: 'SpedilinkCargoList',
  VEHICLE_LIST: 'SpedilinkVehicleList',
  CARGO_OFFER_LIST: 'SpedilinkCargoOfferList',
  VEHICLE_OFFER_LIST: 'SpedilinkVehicleOfferList'
}
